"use strict";
/**
 * Creates a warning for a specified component with the provided message if the environment is not production.
 * @param componentName
 * @param message
 * @returns
 */
Object.defineProperty(exports, "__esModule", { value: true });
const warn = (componentName, message, appName = 'TDS') => {
    if (process.env.NODE_ENV === 'production') {
        return;
    }
    console.warn(`[${appName}] ${componentName}: ${message}`); // eslint-disable-line no-console
};
exports.default = warn;
//# sourceMappingURL=warn.js.map